/**
 * One-shot device location for team check-in (Phase SC-22d).
 *
 * Resolves to a reading or a typed failure — never throws — so the
 * check-in card can render a calm state for each outcome.
 */

export interface LocationReading {
  lat: number;
  lng: number;
  accuracy: number;
}

export type LocationResult =
  | { ok: true; reading: LocationReading }
  | { ok: false; reason: "unsupported" | "denied" | "unavailable" | "timeout" };

export function readLocation(timeoutMs = 15_000): Promise<LocationResult> {
  if (typeof navigator === "undefined" || !("geolocation" in navigator)) {
    return Promise.resolve({ ok: false, reason: "unsupported" });
  }
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          ok: true,
          reading: {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          },
        }),
      (err) =>
        resolve({
          ok: false,
          reason:
            err.code === err.PERMISSION_DENIED
              ? "denied"
              : err.code === err.TIMEOUT
                ? "timeout"
                : "unavailable",
        }),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 },
    );
  });
}
